"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Sep 21 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PriceZoneProductPriceConverter_1 = require("../../../cleaning/conversions/dto/PriceZoneProductPriceConverter");

var ProductInfoConverter_1 = require("../../../product/conversions/ProductInfoConverter");

var InternalProductPricesDTO_1 = require("../../../product/model/InternalProductPricesDTO");

var DataPairingProductRowDTO_1 = require("../../model/dto/DataPairingProductRowDTO");

var CompetitorProductDTOConverter_1 = require("./CompetitorProductDTOConverter");

var DataPairingProductRowDTOConverter_1 = require("./DataPairingProductRowDTOConverter");
/**
 * Implementation of DataPairingProductRowDTOConverter
 *
 * @author RV
 */


var DataPairingProductRowDTOConverterImpl =
/*#__PURE__*/
function (_DataPairingProductRo) {
  _inherits(DataPairingProductRowDTOConverterImpl, _DataPairingProductRo);

  function DataPairingProductRowDTOConverterImpl(competitorProductDTOConverter, priceZoneProductPriceConverter, productInfoConverter) {
    var _this;

    _classCallCheck(this, DataPairingProductRowDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataPairingProductRowDTOConverterImpl).call(this));
    _this.competitorProductDTOConverter = competitorProductDTOConverter;
    _this.priceZoneProductPriceConverter = priceZoneProductPriceConverter;
    _this.productInfoConverter = productInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DataPairingProductRowDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new DataPairingProductRowDTO_1.DataPairingProductRowDTO(conversions.toBigNumber(source.purchasePrice), source.openPurchasePrice ? conversions.toBigNumber(source.openPurchasePrice) : null, conversions.asObjectList(source, 'competitorsProductsDTOs', function (competitorsProductsDTOs) {
        return _this2.competitorProductDTOConverter.toObject(competitorsProductsDTOs, conversions);
      }), this.productInfoConverter.toObject(source.productInfo, conversions), source.family, InternalProductPricesDTO_1.InternalProductPricesDTO.schema.prices.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        purchasePrice: conversions.fromBigNumber(source.purchasePrice),
        openPurchasePrice: source.openPurchasePrice ? conversions.fromBigNumber(source.openPurchasePrice) : null,
        competitorsProductsDTOs: conversions.asObjectArray(source, 'competitorsProductsDTOs', function (competitorsProductsDTOs) {
          return _this3.competitorProductDTOConverter.toDocument(competitorsProductsDTOs, conversions);
        }),
        productInfo: this.productInfoConverter.toDocument(source.productInfo, conversions),
        family: source.family,
        prices: conversions.asObjectArray(source, 'prices', function (p) {
          return _this3.priceZoneProductPriceConverter.toDocument(p, conversions);
        })
      });
      return result;
    }
  }]);

  return DataPairingProductRowDTOConverterImpl;
}(DataPairingProductRowDTOConverter_1.DataPairingProductRowDTOConverter);

DataPairingProductRowDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [CompetitorProductDTOConverter_1.CompetitorProductDTOConverter, PriceZoneProductPriceConverter_1.PriceZoneProductPriceConverter, ProductInfoConverter_1.ProductInfoConverter])], DataPairingProductRowDTOConverterImpl);
exports.DataPairingProductRowDTOConverterImpl = DataPairingProductRowDTOConverterImpl;